module.exports = __webpack_public_path__ + "static/respect-846e07a1db9f345ee1f7f0961784bd65.svg";